import axios from 'axios';

import {
  ROOT,
  SET_PATIENTS,
  PATIENTS_URL,
  SET_CURRENT_PATIENT,
  DEVICES_URL,
  SET_PATIENT_DEVICES,
  SET_PATIENT_COUNT,
  SET_CURRENT_PATIENT_PAUSE_STATE,
} from '../../constants';

export const getPatients = (assignable = false, page = 1, pageSize = 10) => {
  return async (dispatch) => {
    const query = {};
    if (page !== -1 && pageSize !== -1) {
      query.page = page;
      query.page_size = pageSize;
    }
    if (assignable) {
      query.assignable = 1;
    }
    axios
      .get(`${ROOT}${PATIENTS_URL}`, { params: query })
      .then((response) => {
        dispatch(setPatients(response.data.results));
        dispatch(setPatientCount(response.data.count));
      })
      .catch((error) => {
        const { response } = error;
        const { data } = response;
        return { success: false, data };
      });
  };
};

export const getPatient = (id) => {
  return async (dispatch) => {
    axios
      .get(`${ROOT}${PATIENTS_URL}${id}`)
      .then((response) => {
        const match = response.data;
        dispatch(setPatient(match));
        dispatch(getPatientDevices(match));
      })
      .catch((error) => {
        let data = [];
        if (error.response) {
          const { response } = error;
          data = response.data;
        }
        return { success: false, data };
      });
  };
};

export const createPatient = (formData) => {
  return async (dispatch) => {
    axios
      .post(`${ROOT}${PATIENTS_URL}`, formData)
      .then(() => {
        dispatch(getPatients());
      })
      .catch((error) => {
        return error;
      });
  };
};

export const editPatient = (body, id) => {
  return async () => {
    axios.put(`${ROOT}${PATIENTS_URL}${id}/`, body).catch((error) => {
      return error;
    });
  };
};

export const editPatientData = (body, id) => {
  return async () => {
    axios.patch(`${ROOT}${PATIENTS_URL}${id}/`, body).catch((error) => {
      return error;
    });
  };
};

export const deletePatient = (id) => {
  return async () => {
    axios.delete(`${ROOT}${PATIENTS_URL}${id}/`).catch((error) => {
      return error;
    });
  };
};

export const getPatientDevices = (patient) => {
  return async (dispatch) => {
    const requests = [];
    const results = [null, null];
    if (patient.device_a) {
      requests.push(axios.get(`${ROOT}${DEVICES_URL}${patient.device_a.id}`));
    }
    if (patient.device_b) {
      requests.push(axios.get(`${ROOT}${DEVICES_URL}${patient.device_b.id}`));
    }
    axios
      .all(requests)
      .then(
        axios.spread((...responses) => {
          results[0] = responses[0] ? responses[0].data : null;
          results[1] = responses[1] ? responses[1].data : null;
          dispatch(setPatientDevices(results));
        }),
      )
      .catch((errors) => {
        return { success: false, errors };
      });
  };
};

export const setPatient = (patient) => {
  return {
    type: SET_CURRENT_PATIENT,
    patient,
  };
};

export const setPatients = (patients) => {
  return {
    type: SET_PATIENTS,
    patients,
  };
};

export const setPatientCount = (patientCount) => {
  return {
    type: SET_PATIENT_COUNT,
    patientCount,
  };
};

export const setPatientDevices = (patientDevices) => {
  return {
    type: SET_PATIENT_DEVICES,
    patientDevices,
  };
};

export const setPatientPause = (paused) => {
  return {
    type: SET_CURRENT_PATIENT_PAUSE_STATE,
    paused,
  };
};
